/**
 * A failure that shows the running page belongs to a build the server no longer serves, raised where the
 * browser's own error says nothing that would identify it, such as a worker script that failed to load.
 */
export class StaleDeployError extends Error {
	/**
	 * @param message - What failed to load.
	 * @param options - The underlying cause, if any.
	 */
	public constructor(message: string, options?: ErrorOptions) {
		super(message, options);
		this.name = 'StaleDeployError';
	}
}
